<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
          <div class="col-md-12">
            <h3 class="m-0" style="margin-bottom: 10px !important">Map ODC ODP, Teknisi dan Pelanggan</h3>
          </div>
          <div class="col-md-12">
            <div class="card mt-0">
              <div class="card-body" >
                <div class="float-div box-horizontal">
                  <div class="form-group ">
                    <div class="form-inline">
                      <input style="width:400px" type="text" class="form-control" placeholder="Cari ODP / Teknisi..." v-model="cari" v-on:keyup.enter="cariPelanggan()">
                      <button class="btn btn-primary" @click="cariPelanggan()">Cari</button>
                    </div>
                    <div v-show="cariKlik">
                      <label>ODP</label>
                      <ul class="list-group">
                        <li class="list-group-item click m-0" v-for="(i, key) in odpList" @click="pilihList(i)"> 
                          <span class="d-block">Nomor : {{ i.nomor }}</span>
                          <small class="text-secondary">Jumlah Port : {{ i.port }}</small>
                        </li>
                      </ul>
                      <label>Teknisi</label> <!--  -->
                      <ul class="list-group"> 
                        <li class="list-group-item click m-0" v-for="(i, key) in teknisiList" @click="pilihList(i)">
                          <span class="d-block">{{ i.nama }}</span></li>
                      </ul>
                    </div>
                    <ul class="list-group" v-show="cariKosong">
                      <li class="list-group-item">TIDAK ADA DATA / MUNGKIN PELANGGAN BELUM ADA KOORDINATNYA</li>
                    </ul>
                  </div>
                  <div class="form-group ml-4">
                    <div class="form-inline">
                      <div class="mr-2">
                        <span class="d-block">Pelanggan diMap</span>
                        <span>{{jumlahPelanggan}} Pelanggan</span>
                      </div>
                      <button class="btn btn-sm btn-info" @click="loadmorePelanggan()">LoadMore</button>
                    </div>
                  </div>
                </div>
                <div class="row" style="height: 550px">
                  <l-map  ref="map"
                    :zoom="zoom"
                    :center="center"
                    :options="mapOptions"
                    style="height: 100%"
                    @update:center="centerUpdate"
                    @update:zoom="zoomUpdate"
                    @ready="doSomethingOnReady()"
                    >
                    <l-tile-layer
                      :url="url"
                      :attribution="attribution"
                    />
                    
                    <l-marker v-for="(item, key) in marker" v-bind:key="item.id" :lat-lng="getPosition(item.lat, item.lng)" @click="odpDetail(item,item.id)" >
                      <l-popup @add="openPopup">
                        <div>
                          ODP : {{item.nomor}}
                        </div>
                      </l-popup>
                      <l-icon 
                        icon-url="https://beatcom.web.id/assets/marker-biru.png" >
                      </l-icon>
                    </l-marker>
                    
                    <l-marker v-for="(item, key) in markerODC"   v-bind:key="item.lat" :lat-lng="getPosition(item.lat, item.lng)" @click="odcDetail(item,item.id)">
                      <l-popup @add="openPopup">
                        <div>
                          ODC : {{item.nomor}}
                        </div>
                      </l-popup>
                      <l-icon 
                        icon-url="https://beatcom.web.id/assets/marker-orange.png" >
                      </l-icon>
                    </l-marker>
                    
                    <l-marker v-for="(item, key) in markerTeknisi"  v-bind:key="item.lat" :lat-lng="getPosition(item.lat, item.lng)">
                      <l-popup @add="openPopup">
                        <div>
                          {{item.nama}}
                        </div>
                      </l-popup>
                      <l-icon 
                        icon-url="https://beatcom.web.id/assets/marker-teknisi.png" >
                      </l-icon>
                    </l-marker>
                    
                    <l-marker v-for="(item, key) in markerPelanggan"  v-bind:key="item.lat" :lat-lng="getPosition(item.lat, item.lng)">
                      <l-popup @add="openPopup">
                        <div>
                          {{item.nama}}
                        </div>
                      </l-popup>
                      <l-icon 
                        icon-url="https://beatcom.web.id/assets/marker-pelanggan.png" >
                      </l-icon>
                    </l-marker>
                    
                  </l-map>
                
                  <div class="float-div p-2" style="bottom: 0; margin-bottom: 25px; margin-left: 10px;">
                    <span>Info Map :</span>
                    <div class="d-flex" style="width: 300px">
                      <div class="flex-1">
                        <span class="d-block">
                          <img src="https://beatcom.web.id/assets/marker-orange.png" alt="" height="15px">
                          <span>ODC</span>
                        </span>
                        <span class="d-block">
                          <img src="https://beatcom.web.id/assets/marker-biru.png" alt="" height="15px">
                          <span>ODP</span>
                        </span>
                        <span class="d-block">
                          <img src="https://beatcom.web.id/assets/marker-teknisi.png" alt="" height="15px">
                          <span>Teknisi</span>
                        </span>
                        <span class="d-block">
                          <img src="https://beatcom.web.id/assets/marker-pelanggan.png" alt="" height="15px">
                          <span>Pelanggan</span>
                        </span>
                      </div>
                      <div class="flex-1 text-right">
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>

            
            <div class="card mt-0">
              <div class="card-body" >
                <div v-show="detailODP">
                  <h5 class="d-block mt-2 mb-1">Info ODP</h5>
                  <div class="d-flex" style="width: 300px">
                    <div class="flex-1">
                      <span class="d-block">Nomor</span>
                      <strong class="text-info">{{nomorODP}}</strong>
                    </div>
                    <div class="flex-1 text-right">
                      <span class="d-block">Jumlah Port</span>
                      <strong class="text-info">{{portODP}}</strong>
                    </div>
                  </div>
                  <div class="d-flex" style="width: 300px">
                    <div class="flex-1">
                      Port Terpakai
                    </div>
                    <div class="flex-1 text-right">
                      <strong class="text-warning">{{portTerpakai}}</strong>
                    </div>
                  </div>
                </div>

                <h5 class="m-0 mt-3" style="margin-bottom: 10px !important">List Pelanggan</h5>
                
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th width="40px">No.</th>
                      <th>Nama</th>
                      <th>Telepon</th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in markerPelanggan">
                        <td>{{ index+1 }}</td>
                        <td>{{ u.nama }} </td>
                        <td>{{ u.wa }} </td>
                      </tr>
                      <tr v-if="markerPelanggan.length == 0">
                        <td></td>
                        <td>Tidak ada Data </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
            
            <div class="alert alert-success m-0" role="alert">
              FYI : Mengingat ini bukan Google Map (berbayar) tapi ini Leaflet, jadi maklumilah kalo mungkin nama letak daerahnya beda. Google map mahal pak wkwkkw
            </div>

          </div>
          
      </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import inter from '@/globalFunc/Interface' 

import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LIcon } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import myGlobal from '@/globalFunc/myGlobal' 
import { RedisSession } from '@/globalFunc/redis';

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);

export default {
  name: 'Beranda', 
  components: { 
		LMap,
		LTileLayer,
		LMarker,
		LPopup,
		LTooltip,
    LIcon
  },
  props: {
    options: {type: Object, default: () => {}},
  },
  data () {
    return {
			markerList: [],
			marker: [],
			markerODC: [],
      markerTeknisi: [],
      markerPelanggan: [],
      markerPelangganAll: [],
      
			zoom: 12,
			center: [-0.2664523,115.8973852],
			url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
			attribution:
				'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
			withPopup: latLng(-8.102982, 113.222425), 
			currentZoom: 11.5,
			showParagraph: false,
			mapOptions: {
				closePopupOnClick: false,
        doubleClickZoom: 'center',
				zoomSnap: 0.5
			},

      nama: '',
      telepon: '',
      cari: '',
      cariKlik: false,
      cariKosong: false,
      map: '',

      lineGroup: null,

      odpList: [],
      teknisiList: [],

      nomorODP: null,
      portODP: null,
      portTerpakai: null,
      detailODP: false,
      pagePelanggan: 0,
      jumlahPelanggan: 0
    }
  },
  methods: {
    doSomethingOnReady() {
      this.map = this.$refs.map.mapObject;
      
      this.getData();
      this.getODC();
      this.getTeknisi();
      this.getPelangganSekitar();
    },
    openPopup: function (event) {
      this.$nextTick(() => {
        event.target.openPopup();
      })
    },
		zoomUpdate(zoom) {
			this.currentZoom = zoom;
		},
		centerUpdate(center) {
      //console.log(lat);
			this.currentCenter = center;
		},
		showLongText() {
			this.showParagraph = !this.showParagraph;
		},

		getPosition: function(lat,lng) {
			return {
				lat: lat,
				lng: lng
			}
		},
    cariPelanggan() {
      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken'),
        cari: this.cari
      }
      
      var apiUrl = inter.ODPMultiCari();
      this.PostData(data,apiUrl).then(x => {
        //console.log(JSON.stringify(x));
        if (x.status == true) {

          this.odpList = x.data.odp;
          this.teknisiList = x.data.teknisi;

          this.cariKlik = true;
          this.cariKosong = false;
        } else {
          this.cariKosong = true;
        }
      })
    },
    pilihList(data) {
			var center = [data.lat, data.lng];
      this.map.panTo(center);
      
      this.cariKlik = false;
    },
    getData() {
      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken'),
        page: "ODP"
      }
      
      var apiUrl = inter.ODPList();
      this.PostData(data,apiUrl).then(x => {
        
        if (x.status == true) {
          this.marker = x.data;

          //console.log(this.center);

          if (x.data.length > 0) {
            this.map.setView(new L.latLng(this.marker[0].lat, this.marker[0].lng));
          }

        } else {

          //alert(x.pesan);

        }
      })
    },
    getODC() {
      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken'),
        page: null
      }
      
      var apiUrl = inter.ODPList();
      this.PostData(data,apiUrl).then(x => {

        //console.log(JSON.stringify(x.data));
        
        if (x.status == true) {

          //this.doSomethingOnReady();
          this.markerODC = x.data;

        } else {

          //alert(x.pesan);

        }
      })
    },
    getTeknisi() {
      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken')
      }
      
      var apiUrl = inter.ODPTeknisi();
      this.PostData(data,apiUrl).then(x => {
        // console.log(JSON.stringify(x.data));
        
        if (x.status == true) {
          this.markerTeknisi = x.data;

        } else {

          //alert(x.pesan);

        }
      })
    },
    loadmorePelanggan() {
      this.pagePelanggan = this.pagePelanggan + 1;

      this.getPelangganSekitar();
    },
    getPelangganSekitar() {
      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken'),
        bulan: myGlobal.getBulan(),
        tahun: myGlobal.getTahunNow(), 
        page: this.pagePelanggan
      }
 
      //myGlobal.loger(data);
      
      var apiUrl = inter.ListPelangganSekitarJSON();
      this.PostData(data,apiUrl).then(x => {
        
        if (x.status == true) {
          
          var data = x.data;
          
          var values = [];
          var i;
          for (i = 0; i < data.length; i++) {
            if(data[i].user.lat != null) {
              data[i].user.nama = data[i].user.unama;
              
              if(this.pagePelanggan > 0) {
                this.markerPelangganAll.push(data[i].user);
              } else {
                values.push(data[i].user);
              }
            }
          }

          if(this.pagePelanggan > 0) {
            //this.markerPelangganAll.push(values);
          } else {
            this.markerPelangganAll = values;
          }

          this.markerPelanggan = this.markerPelangganAll;

          this.jumlahPelanggan = x.page;

        } else {

          //alert(x.pesan);

        }
      })
    },
    odpDetail(data,id) {
      // console.log(JSON.stringify(data));
      this.pagePelanggan = 0; // reset pelanggan

      this.nomorODP = data.nomor;
      this.portODP = data.port;
      this.detailODP = true;
      let latODP = data.lat;
      let lngODP = data.lng;

      this.getPelanggan(id, latODP, lngODP);
    },
    odcDetail(data,id) {
      this.detailODP = false;
      this.markerPelanggan = [];

    },
    getPelanggan(odpID, latODP, lngODP) {
      
      let cacheT = "pel_sekitar-"+odpID; // REDIS ====================================

      const cached = RedisSession.get(cacheT);
      if (cached) {
          let x = cached;

          // LANJUT DI BAWAH
          this.pasangGetPelanggan(x, latODP, lngODP);

          myGlobal.loger("dari radis "+cacheT);

          return false;
      }

      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken'),
        page: "ODP",
        parent: odpID
      }
      
      var apiUrl = inter.ODPPelanggan();
      this.PostData(data,apiUrl).then(x => {

        RedisSession.set(cacheT, x, 300000); // 5 menit

        this.pasangGetPelanggan(x, latODP, lngODP);

      })
    },
    pasangGetPelanggan(x, latODP, lngODP) {
      
      //myGlobal.loger(x);
        
      if(this.lineGroup) {
        this.lineGroup.clearLayers();
      }
      
      if (x.status == true) {
        this.markerPelanggan = x.data;

        this.portTerpakai = x.data.length;

        this.lineGroup = L.layerGroup().addTo(this.map);

        var myGroup = this.lineGroup;
        
        var data = x.data;
        var i;
        for (i = 0; i < data.length; i++) {
          
          //myGlobal.loger(data[i].lat);

          let lat = data[i].lat;
          let lng = data[i].lng;

          var point1 = [latODP, lngODP];
          var point2 = [lat, lng];
          var latlngs = [point1, point2];

          // Membuat garis (polyline) dan menambahkannya ke map
          var polyline = L.polyline(latlngs, {
              color: '#3498db',      // Warna garis
              weight: 5,         // Ketebalan garis (pixel)
              opacity: 0.7,      // Transparansi
              smoothFactor: 1    // Menghaluskan garis saat zoom

          }).addTo(myGroup);

        }


      } else {
        this.markerPelanggan = [];

        this.portTerpakai = "0";
      }
    }

  }, 
  mounted () {
    document.title = "Map Pelanggan";

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
.click {
  cursor: pointer;
}
.click:hover {
  background-color: #eee;
}
.float-div {
  position: absolute;
  z-index: 9999;
  background-color: #fff;
  border-radius: 10px;
  padding: 0px 20px;
  margin-top: 10px;
  margin-left: 40px;
  border: 2px solid #aeaeae;
}
.list-group-item {
  border-bottom: 1px solid #aeaeae;
}
.list-group-item:last-child {
  border-bottom: 1px solid #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/map/main.vue